import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { initDefaultCategories } from '../lib/initCategories';

export function useCategories(userId) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!userId) return;

    let { data } = await supabase
      .from('categories')
      .select('*')
      .eq('user_id', userId)
      .order('sort_order', { ascending: true })
      .order('created_at', { ascending: true });

    // 카테고리가 없으면 기본 카테고리 생성 후 재조회
    if (data && data.length === 0) {
      await initDefaultCategories(userId);
      const { data: initialized } = await supabase
        .from('categories')
        .select('*')
        .eq('user_id', userId)
        .order('sort_order', { ascending: true })
        .order('created_at', { ascending: true });
      data = initialized;
    }

    // 먼저 화면에 표시 (중복 포함 → 클라이언트에서 필터)
    if (data && data.length > 0) {
      const seen = new Set();
      const unique = [];
      const dupeIds = [];
      for (const cat of data) {
        if (seen.has(cat.name)) {
          dupeIds.push(cat.id);
        } else {
          seen.add(cat.name);
          unique.push(cat);
        }
      }
      setCategories(unique);
      // DB 중복 정리는 백그라운드
      if (dupeIds.length > 0) {
        supabase.from('categories').delete().in('id', dupeIds);
      }
    } else {
      setCategories(data || []);
    }

    setLoading(false);
  }, [userId]);

  useEffect(() => { refetch(); }, [refetch]);

  return { categories, loading, refetch };
}
